import { useState, useEffect, useRef } from 'react'
import { Layout } from 'antd'
import { CommentOutlined } from '@ant-design/icons'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getProfileData } from '../../redux/actions/UserAuth'
import { setNavbarHeight } from '../../redux/actions/Theme'
import { initializePusher } from '../../configs/pusher'
import { openNotification } from '../../utils/utils'
import { ADMIN_PREFIX_PATH } from '../../configs/AppConfig'

import AdminViews from '../../views/admin-views'
import Sidenav from '../../components/layout-components/Sidenav'
import HeaderNav from '../../components/layout-components/HeaderNav'
import ModalComponent from '../../features/components/Modal'
import TabFilter from '../../features/components/form/TabFilter'

const { Header, Sider, Content } = Layout

const userTypeTabsFilter = [
  { label: 'Online', key: 'Online' },
  { label: 'Partner', key: 'Partner' },
]

export function AdminLayout() {
  const dispatch = useDispatch()
  const ref = useRef(null)
  const location = useLocation()
  const history = useHistory()

  const { permissions } = useSelector((state) => state.myProfile)
  const hasTicketsViewPermission = permissions?.some(
    (permission) => permission.name === 'ticket:view'
  )

  const isChatPage =
    location.pathname.split('/')[3] === 'Messages' &&
    location.pathname.split('/')?.[4] !== 'Statistics'
  const isHomePage = location.pathname.split('/')[3] === 'Home'

  const [navOpen, setNavOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    dispatch(getProfileData('admin'))
  }, [dispatch])

  useEffect(() => {
    dispatch(setNavbarHeight(ref.current.clientHeight))
  }, [dispatch, isChatPage])

  useEffect(() => {
    if (permissions) {
      const pusher = initializePusher(true)
      const channelName = 'private-chat_rooms'
      const existingChannel = pusher.channel(channelName)
      const messageSound = new Audio('/sounds/mixkit-correct-answer-tone.wav')

      // HANDLE USER TYPE ON NAVIGATION
      if (!existingChannel && hasTicketsViewPermission) {
        const channel = pusher.subscribe(channelName)

        channel.bind('chat_room_created', function (newRoom) {
          messageSound.play().catch((error) => {
            console.error('Error playing sound:', error)
          })

          openNotification(
            'success',
            <p className='text-dimmed'>{newRoom.last_message}</p>,
            <h6 className='fw-semibold'>
              New chat from {newRoom.client.fname} {newRoom.client.lname || ''}
            </h6>,
            <CommentOutlined className='text-green' />,
            () =>
              history.push(
                `${ADMIN_PREFIX_PATH}/Messages?id=${newRoom.id}&user_type=${
                  newRoom.client.type === 'reseller' ? 'Partner' : 'Online'
                }`
              ),
            { cursor: 'pointer' }
          )
        })

        channel.bind('chat_room_updated', function (newData) {
          messageSound.play().catch((error) => {
            console.error('Error playing sound:', error)
          })
          openNotification(
            'success',
            <p className='text-dimmed'>{newData.last_message}</p>,
            <h6 className='fw-semibold'>
              New chat from {newData.client.fname} {newData.client.lname || ''}
            </h6>,
            <CommentOutlined className='text-green' />,
            () =>
              history.push(
                `${ADMIN_PREFIX_PATH}/Messages?id=${newData.id}&user_type=${
                  newData.client.type === 'reseller' ? 'Partner' : 'Online'
                }`
              ),
            { cursor: 'pointer' }
          )
        })

        return () => {
          pusher.unsubscribe(channelName)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions])

  return (
    <>
      <Layout id='scroller' className='dashboard-layout'>
        <Sider className={`${navOpen ? 'nav-open' : ''}`} collapsed={collapsed}>
          <Sidenav {...{ navOpen, setNavOpen }} />
        </Sider>
        <Layout id='scroller'>
          <Header
            ref={ref}
            className={`${
              isChatPage || isHomePage ? 'pt-4 pb-0' : 'py-4'
            } px-0 position-sticky top-0`}
            style={{
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              zIndex: '99',
            }}
          >
            <HeaderNav {...{ navOpen, setNavOpen, collapsed, setCollapsed }} />
            {(isChatPage || isHomePage) && (
              <TabFilter filterName='user_type' tabs={userTypeTabsFilter} />
            )}
          </Header>
          <Content>
            <AdminViews />
          </Content>
        </Layout>
      </Layout>
      <ModalComponent />
    </>
  )
}

export default AdminLayout
